<template>
  <div>
    <h3 class="color-darkblue">Other Charges</h3>
    <div class="table-responsive-sm mt-4">
      <table class="table table-bordered table-sm" style="table-layout: fixed;">
        <thead>
          <tr class="table-primary">
            <th scope="col" class="" style="width: 15%">Expense Type</th>
            <th scope="col">Description</th>
            <th scope="col" class="text-right">Invoice Number</th>
            <th scope="col" class="text-right">Invoice Date</th>
            <th scope="col" class="text-right">Charges Claimed</th>
            <th scope="col" class="text-right">Charges Processed</th>
            <th scope="col" class="text-right">Supporting Documentation</th>
            <th scope="col"> Action</th>
          </tr>
        </thead>
        <tbody>
          <tr v-for="(row, index) in rows" :key="index">

            <td>
              <v-select v-model="row.expense_type" :id="'expense_type_' + index" :name="'expense_type_' + index"
                label="text" :options="expenseTypeArr" placeholder="Select Expense Type"
                class='custom-ci-auto-search contract-data'>
              </v-select>
              <div class="field-error">{{ row.expense_type_error_msg }}</div>
            </td>
            <td>
              <input type="text" placeholder="description" v-model="row.description" style="width:99% !important"
                :id="'srt' + index" :name="'srt' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" placeholder="invoice number" v-model="row.invoice_id" style="width:99% !important"
                :id="'invoice_id' + index" :name="'invoice_id' + index" class="vgt-input text-right">
            </td>
            <td>
              <input type="date" placeholder="Invoice Date" v-model="row.invoice_date" :id="'invoice_date' + index"
                style="width:99% !important" :name="'invoice_date' + index" class="vgt-input text-right">
              <div class="field-error">{{ row.invoice_date_error_msg }}</div>
            </td>
            <td>
              <input type="number" placeholder="Charges Claimed" v-model="row.charges_claimed"
                :id="'charges_claimed' + index" style="width:99% !important" :name="'charges_claimed' + index"
                class="vgt-input text-right">
              <div class="field-error">{{ row.charges_claimed_error_msg }}</div>
            </td>
            <td>
              <input type="text" disabled placeholder="Charges Processed" v-model="row.charges_processed"
                id="charges_processed" name="charges_processed" style="width:99% !important" class="vgt-input text-right">
            </td>
            <td>
              <input type="text" placeholder="Supporting Documentation" v-model="row.supporting_documentation"
                id="supporting_documentation" name="supporting_documentation" style="width:99% !important"
                class="vgt-input text-right">
              <div class="field-error">{{ row.supporting_documentation_error_msg }}</div>
            </td>
            <td class="text-center valign-middle">
              <template v-if="rows.length != 1">
                <a href="javascript:void(0);" v-on:click="removeItem(index);"> <i class="fp-remove"></i> </a>
              </template>
              <template v-else>
                <span class="close-row"> _ </span>
              </template>
            </td>

          </tr>
        </tbody>
      </table>
    </div>
    <div class="btn-groups mb-4">
      <button type="submit" v-on:click.prevent="addRow()" class="btn btn-primary">
        <i class="fp-add"></i> Add Other Charge
      </button>
      <button type="button"
        v-on:click="updateLineItems()" class="btn btn-primary">
        <i class="fp-edit"></i> Edit
      </button>
    </div>
  </div>
</template>
<script>
import Vue from 'vue';
import { contractMixins } from "../../mixins/contractMixins";
import { commonMixins } from "../../mixins/commonMixins";

export default {
  name: "EvOtherChargesLineItemsSection",
  props: ["lineItemData", "claimId", "hideEditSection"],
  mixins: [commonMixins, contractMixins],
  data: () => ({
    rows: [],
    expenseTypeArr: ['FREIGHT', 'OTHER', 'TOWING'],
    travelRows: [],
    otherChargesTotalTable: [],
    location_id: null,
    zip: null,
    phone_no: null,
    city_id: null,
    state: null,
    street_address: null,
  }),
  created() {
    this.populateData();
  },
  methods:{
    populateData(){
      for(let i = 0; i < this.lineItemData[0].rows.length; i++){
          this.rows.push(this.lineItemData[0].rows[i]);
        }
        for(let i = 0; i < this.lineItemData[0].travelRows.length; i++){
          this.travelRows.push(this.lineItemData[0].travelRows[i]);
        }
        for(let i = 0; i < this.lineItemData[0].otherChargesTotalTable.length; i++){
          this.otherChargesTotalTable.push(this.lineItemData[0].otherChargesTotalTable[i]);
        }
        this.location_id = this.lineItemData[0].location_id;
        this.zip = this.lineItemData[0].zip;
        this.phone_no = this.lineItemData[0].phone_no;
        this.city_id = this.lineItemData[0].city_id;
        this.state = this.lineItemData[0].state;
        this.street_address = this.lineItemData[0].street_address;
    },
    removeItem(index) {
      if (this.rows.length > 1) {
        this.rows.splice(index, 1);
      }
    },
    addRow() {
      var index = this.rows.length - 1;
      var success = this.validateSelectedRow(index);
      if (success) {
        this.rows.push({
          expense_type: "",
          description: "",
          invoice_no: "",
          invoice_date: "",
          charges_claimed: 0,
          charges_processed: 0,
          supporting_documentation: "",
          supporting_documentation: "",
          expense_type_error_msg: "",
          invoice_error_msg: "",
          invoice_date_error_msg: "",
          charges_claimed_error_msg: "",
          supporting_documentation_error_msg: "",
        });
      }
    },
    validateSelectedRow(index) {
      var success = true;
      this.clearRowErrorMessages(index);
      if (this.rows[index].expense_type == null || this.rows[index].expense_type == "") {
        this.rows[index].expense_type_error_msg = "Expense Type Required";
        success = false;
      }
      if (this.rows[index].invoice_id == null || this.rows[index].invoice_id == "") {
        this.rows[index].invoice_error_msg = "Invoice Required";
        success = false;
      }
      if (this.rows[index].invoice_date == null || this.rows[index].invoice_date == "") {
        this.rows[index].invoice_date_error_msg = "Invoice Date Required";
        success = false;
      }
      if (this.rows[index].charges_claimed == null || this.rows[index].charges_claimed == 0) {
        this.rows[index].charges_claimed_error_msg = "Charges Claimed Required";
        success = false;
      }
      if (this.rows[index].supporting_documentation == null || this.rows[index].supporting_documentation == 0) {
        this.rows[index].supporting_documentation_error_msg = "Supporting Documentation Required";
        success = false;
      }
      return success;
    },
    validateAllRowsForSend() {
      var success = false;
      for (var i = 0; i < this.rows.length; i++) {
        var success = this.validateSelectedRow(i);
        if (!success) {
          break;
        }
      }
      return success;
    },
    clearRowErrorMessages(index) {
      this.rows[index].expense_type_error_msg = "";
      this.rows[index].invoice_error_msg = "";
      this.rows[index].invoice_date_error_msg = "";
      this.rows[index].charges_claimed_error_msg = "";
      this.rows[index].supporting_documentation_error_msg = "";
    },
    prepareDataForUpdating(){
      const lineItemData = {
        rows: this.rows,
        travelRows: this.travelRows,
        otherChargesTotalTable: this.otherChargesTotalTable,
        state: this.state,
        city_id: this.city_id,
        street_address: this.street_address,
        location_id: this.location_id,
        zip: this.zip,
        phone_no: this.phone_no,
      };
      return lineItemData;
    },
    updateLineItems(){
      var self = this;
      const lineItemData = this.prepareDataForUpdating();
      self.$parent.loading = true;
      $.ajax({
          url: process.env.ROOT_API + "/update/other-charges-line-items",
          type: "POST",
          data: {
            lineItemData: lineItemData,
            claimId: self.claimId,
          },
          headers: this.ajxHeaders,
          dataType: "json",
          cors: true,
          success: function (data) {
            self.$parent.loading = false;
            if (data.status == "success") {
              self.hideEditSection("other_charges_line_items");
            } else {
              console.log("Error");
            }
          },
          error: function (jqXHR, exception) {
            self.$parent.loading = false;
            console.log("ERRORRRR");
          },
        });
    },
  },
}
</script>



// WEBPACK FOOTER //
// src/components/warrantyClaimTabs/EvOtherChargesLineItemsSection.vue